import { render, staticRenderFns } from "./FabricComparisonDisclaimer.vue?vue&type=template&id=867740f2&scoped=true&"
import script from "./FabricComparisonDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./FabricComparisonDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./FabricComparisonDisclaimer.vue?vue&type=style&index=0&id=867740f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867740f2",
  null
  
)

export default component.exports